import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function MaskLine({ children, delay = 0, duration = 1, className = "" }) {
  return (
    <span className="block overflow-hidden">
      <motion.span
        className={"block will-change-transform " + className}
        initial={{ y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function MaskLineInView({ children, delay = 0, className = "" }) {
  return (
    <motion.span
      className="block overflow-hidden"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <motion.span
        className={"block will-change-transform " + className}
        variants={{
          hidden: { y: "112%" },
          visible: { y: "0%", transition: { duration: 0.9, delay, ease: EASE } },
        }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
}

export function FadeUp({ children, delay = 0, y = 26, amount = 0.15, once = true, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, tone = "dark-bg", className = "" }) {
  const color = tone === "dark-bg" ? "text-gold-light" : "text-gold";
  return (
    <p className={"font-mono text-[11px] uppercase tracking-[0.3em] " + color + " " + className}>
      {children}
    </p>
  );
}

export function SectionHeading({ eyebrow, titleLines, tone = "dark-bg", intro, className = "" }) {
  const isDark = tone === "dark-bg";
  return (
    <div className={className}>
      <FadeUp>
        <Eyebrow tone={tone}>{eyebrow}</Eyebrow>
        <div className={"mt-4 h-px w-14 " + (isDark ? "bg-gold/60" : "bg-gold")} />
      </FadeUp>
      <h2 className={"mt-6 font-serif text-4xl leading-[1.08] tracking-tight sm:text-5xl lg:text-[3.4rem] " + (isDark ? "text-cream" : "text-navy")}>
        {titleLines.map((line, i) => (
          <MaskLineInView key={i} delay={0.08 * i}>{line}</MaskLineInView>
        ))}
      </h2>
      {intro ? (
        <FadeUp delay={0.15}>
          <p className={"mt-6 max-w-xl text-base leading-relaxed " + (isDark ? "text-cream/75" : "text-navy/70")}>
            {intro}
          </p>
        </FadeUp>
      ) : null}
    </div>
  );
}
